"use strict";

exports.__esModule = true;
var _UpdateAlertWatcherRuleScreen = require("./UpdateAlertWatcherRuleScreen");
Object.keys(_UpdateAlertWatcherRuleScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UpdateAlertWatcherRuleScreen[key]) return;
  exports[key] = _UpdateAlertWatcherRuleScreen[key];
});